if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends DetailsDisclosure {
      constructor() {
        super();

        this.elements = {
          shareButton: this.querySelector('button'),
          shareSummary: this.querySelector('summary'),
          closeButton: this.querySelector('.share-button__close'),
          successMessage: this.querySelector('[id^="ShareMessage"]'),
          urlInput: this.querySelector('input'),
        };
        this.urlToShare = this.elements.urlInput
          ? this.elements.urlInput.value
          : document.location.href;
        this.shareTitle = this.dataset.shareTitle || document.title;
        this.shareText = this.dataset.shareText || '';

        if (navigator.share) {
          this.mainDetailsToggle.setAttribute('hidden', '');
          this.elements.shareButton.classList.remove('hidden');
          this.elements.shareButton.addEventListener('click', (e) => {
            this.shareInfo(e);
          });
        } else {
          this.mainDetailsToggle.addEventListener(
            'toggle',
            this.toggleDetails.bind(this),
          );
          this.mainDetailsToggle
            .querySelector('.share-button__copy')
            .addEventListener('click', this.copyToClipboard.bind(this));
          this.mainDetailsToggle
            .querySelector('.share-button__close')
            .addEventListener('click', this.close.bind(this));
        }
      }

      async shareInfo(event) {
        try {
          const shareData = {
            text: `${this.shareTitle}\n${this.shareText}\n${this.urlToShare}`,
          };

          if (navigator.canShare) {
            this.mainDetailsToggle.setAttribute('hidden', '');
            this.elements.shareButton.classList.remove('hidden');
            await navigator.share(shareData);
            this.ga4TrackEvent(event);
          }
        } catch (error) {
          console.error('An error occurred during the share execution:', error);
        }
      }

      toggleDetails() {
        if (!this.mainDetailsToggle.open) {
          this.elements.successMessage.classList.add('hidden');
          this.elements.successMessage.textContent = '';
          this.elements.closeButton.classList.add('hidden');
          this.elements.shareSummary.focus();
        }
      }

      copyToClipboard() {
        navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
          this.elements.successMessage.classList.remove('hidden');
          this.elements.successMessage.textContent =
            window.accessibilityStrings.shareSuccess;
          this.elements.closeButton.classList.remove('hidden');
          this.elements.closeButton.focus();
        });
      }

      updateUrl(url) {
        this.urlToShare = url;
        this.elements.urlInput.value = url;
      }

      ga4TrackEvent(e) {
        const ga4Object = {
          event: 'select_content',
          event_params: {
            cta_location: `${window.location.pathname}`,
            link_url: `https://${window.location.hostname}${window.location.pathname}`,
            content_type: `${e.target.dataset.ga4ContentType}`,
            content_name: `${e.target.dataset.ga4ContentName}`,
            link_text: `${e.target.innerText}`,
          },
        };

        ExecuteGA4Event(ga4Object);
      }
    },
  );
}
